import React from 'react';
import { withRouter } from 'react-router-dom';
import numeral from 'numeral';

import { ClassroomQuizSession } from 'Domain/ClassroomQuiz';
import { useQuizContext } from 'Context/QuizContext';

import { QUIZ_SUB_ROUTES } from '../../constant';

const getAverageScore = (sessions) => {
  const culmulativeScore = sessions.reduce((acc, value) => {
    return acc + value.score;
  }, 0);
  const averageScore = culmulativeScore / sessions.length;
  return numeral(averageScore).format('0[.]00');
};

const Landing = ({ history, match, children }) => {
  const {
    metadata: { title, maxAttempts },
  } = useQuizContext();

  const { examId, examSessionId: paramExamSessionId } = match.params;

  return (
    <ClassroomQuizSession>
      {({ quizSessions, startSession, examSessionId, isLoadingQuizSession }) => {
        const currentSession = quizSessions.find((session) => {
          return session.id === paramExamSessionId;
        });
        const { score, fullScore, round } = currentSession || {};

        if (examSessionId) {
          const path = QUIZ_SUB_ROUTES.SESSION.getPath(examId, examSessionId);
          history.push(path);
        }

        return children({
          score,
          fullScore,
          averageScore: getAverageScore(quizSessions),
          round,
          title,
          isQuizStarting: isLoadingQuizSession,
          onDoQuizAgain: async () => {
            await startSession();
          },
          onSeeSolution: () => {
            history.push(QUIZ_SUB_ROUTES.SOLUTION.getPath(examId, paramExamSessionId, round));
          },
          onSeeMoreScore: () => {
            history.push(QUIZ_SUB_ROUTES.LANDING.getPath(examId));
          },
          isLastAttempt: quizSessions.length >= maxAttempts,
        });
      }}
    </ClassroomQuizSession>
  );
};

export default withRouter(Landing);
